export default function TextPoints({ isFound = true, text = '' }) {
  const baseClasses = 'px-2 max-w-xs font-bold';
  const colorClass = isFound ? 'text-blue' : 'text-gray';

  return <span className={`${baseClasses} ${colorClass}`}>{text}</span>;
}
